/**
 * Shared events data.
 * Add Pleasant Playground Community Garden events here.
 */

import donutsForDads from '../images/donutsForDads.jpg';
import gardenProduceExchange from '../images/gardenProduceExchangeEventimage.png';
import pickYourOwnHarvestDay from '../images/pick-your-own-harvest-day-2026-07-12.png';
import pickYourOwnGreens from '../images/PickYourOwnGreens.jpg';
import volunteersNeeded from '../images/optimized/volunteersNeeded.jpg';

const MONTHS = {
  Jan: 0,
  January: 0,
  Feb: 1,
  February: 1,
  Mar: 2,
  March: 2,
  Apr: 3,
  April: 3,
  May: 4,
  Jun: 5,
  June: 5,
  Jul: 6,
  July: 6,
  Aug: 7,
  August: 7,
  Sep: 8,
  Sept: 8,
  September: 8,
  Oct: 9,
  October: 9,
  Nov: 10,
  November: 10,
  Dec: 11,
  December: 11,
};

const rawEvents = [
  {
    id: 'garden-produce-exchange-day-2026-08-08',
    month: 'August',
    day: '8',
    year: '2026',
    title: 'Garden Produce Exchange Day',
    category: 'Community',
    tags: ['Community', 'Food', 'Produce Exchange', 'Free Garden Starts'],
    details: 'Saturday, August 8th, 11 AM - 1 PM. All garden members are welcome.',
    location: 'Pleasant Playground Community Garden, 6757 Chew Avenue',
    time: '11 AM - 1 PM',
    duration: '2 hr',
    description:
      'Join us for our first Garden Produce Exchange Day! Bring extra tomatoes, peppers, herbs, cucumbers, greens, or other garden goodies to exchange with fellow gardeners. Discover new varieties, share recipes and growing techniques, and celebrate the abundance of our garden together.',
    additionalDescription:
      'Our hope is that this becomes more than a produce swap—a gathering where gardeners can learn from one another, celebrate the diversity of what we grow, and strengthen our community through sharing food and knowledge. Come to exchange produce, pick up fall starts, or simply spend time with fellow gardeners.',
    freeStarts: [
      'Kale',
      'Collards',
      'Broccoli',
      'Scallions',
      'Cabbage',
      'Mustard Greens',
      'Fennel',
      'Bok Choy',
      'Lettuce',
      'Napa Cabbage',
    ],
    freeStartsNote: 'Free fall vegetable starts will be available while supplies last.',
    image: gardenProduceExchange,
    imageAlt: 'Garden Produce Exchange Day and free fall garden starts event flyer',
  },
  {
    id: 'pick-your-own-harvest-day-2026-07-12',
    month: 'July',
    day: '12',
    year: '2026',
    title: '4th Free Pick-Your-Own Harvest Day',
    category: 'Harvest',
    tags: ['Community', 'Food', 'Harvest'],
    details:
      'Sunday, July 12th, 10 AM - 12 PM. Registration required; space is limited to 15 people.',
    location: 'Pleasant Playground Community Garden, 6757 Chew Avenue',
    time: '10 AM - 12 PM',
    duration: '2 hr',
    description:
      'Join neighbors for a free pick-your-own harvest day with kale, collard greens, onions, and a small quantity of cucumbers while they last. The first 10 registered participants will receive a free head of cabbage, and participation is capped at 15 people because quantities are limited.',
    registrationNote:
      'Registration is required for this event. Space is limited to 15 participants.',
    registrationUrl:
      'https://www.eventbrite.com/e/free-pick-your-own-harvest-day-tickets-1993750401120?aff=oddtdtcreator',
    image: pickYourOwnHarvestDay,
    imageAlt: 'Free Pick-Your-Own Harvest Day event flyer',
  },
  {
    id: 'pick-your-own-greens-2026',
    month: 'June',
    day: '13',
    year: '2026',
    title: 'Free Pick-Your-Own Greens',
    category: 'Harvest',
    tags: ['Community', 'Food'],
    details: 'Saturday, June 13th, 10 AM - 12 PM. Collard greens, kale, and mustard greens.',
    location: '6757 Chew Avenue',
    time: '10 AM - 12 PM',
    duration: '2 hr',
    description:
      'Neighbors were invited to harvest fresh collard greens, kale, and mustard greens straight from the garden, first come first pick while supplies lasted.',
    image: pickYourOwnGreens,
    imageAlt: 'Free Pick-Your-Own Greens event flyer',
  },
  {
    id: 'pool-beautification-volunteers-2026',
    month: 'June',
    day: '20',
    year: '2026',
    title: 'Pool Beautification Project Volunteers Needed',
    category: 'Volunteer',
    tags: ['Volunteer', 'Pool', 'Beautification'],
    details: 'Saturday, June 20th, 8 AM - 10 AM. No gardening experience required.',
    location: 'Pleasant Playground Pool Area, 6757 Chew Avenue',
    time: '8 AM - 10 AM',
    duration: '2 hr',
    description:
      'Help prepare flower pots for summer planting and create a welcoming pool area for the community. Volunteer activities include weeding planters, adding fresh soil, caring for existing perennials, and watering and plant care. To volunteer, text Lisa at (267) 289-1057.',
    image: volunteersNeeded,
    imageAlt: 'Volunteers Needed Pool Beautification Project flyer',
  },
  {
    id: 'donuts-for-dads-2026',
    month: 'June',
    day: '20',
    year: '2026',
    title: 'Donuts for Dads',
    category: 'Community',
    tags: ['Community', 'Family'],
    details: "Saturday, June 20th, 10 AM - 12 PM. Duration: 2 hr.",
    location: '6757 Chew Avenue',
    time: '10 AM - 12 PM',
    duration: '2 hr',
    description:
      "Join us Saturday June 20th from 10a-12p to celebrate Father's Day at the Pleasant Playground Community Garden, 6757 Chew Avenue in East Mt Airy, Philadelphia.",
    image: donutsForDads,
    imageAlt: 'Donuts for Dads event flyer',
  },
];

function parseEventDate(evt) {
  if (!evt || !evt.day) return null;
  const dayStr = String(evt.day).trim();
  if (!dayStr || dayStr.toLowerCase() === 'tba') return null;
  const year = Number(evt.year) || new Date().getFullYear();
  const monthIndex = MONTHS[evt.month] ?? MONTHS[String(evt.month).slice(0, 3)];
  const day = Number(dayStr);
  if (Number.isNaN(day) || monthIndex == null) return null;
  const date = new Date(year, monthIndex, day);
  date.setHours(0, 0, 0, 0);
  return date;
}

const startOfToday = new Date();
startOfToday.setHours(0, 0, 0, 0);

export const upcomingEvents = [];
export const pastEvents = [];

const sortedEvents = [...rawEvents].sort((eventA, eventB) => {
  const dateA = parseEventDate(eventA)?.getTime() ?? Number.MAX_SAFE_INTEGER;
  const dateB = parseEventDate(eventB)?.getTime() ?? Number.MAX_SAFE_INTEGER;

  if (dateA !== dateB) return dateA - dateB;
  return rawEvents.indexOf(eventA) - rawEvents.indexOf(eventB);
});

sortedEvents.forEach((event) => {
  const eventDate = parseEventDate(event);
  if (eventDate && eventDate < startOfToday) {
    pastEvents.push(event);
  } else {
    upcomingEvents.push(event);
  }
});

pastEvents.reverse();
